if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails || !this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });

        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          // Nicht scrollen, wenn das Bild bereits im Blickfeld liegt.
          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        thumbnail
          .querySelector('button')
          .setAttribute('aria-current', true);

        const thumbnailList = this.elements.thumbnails.slider;
        if (!thumbnailList) return;

        // Desktop: nur die linke Miniaturleiste vertikal bewegen.
        // Mobil: bisherige horizontale Slider-Steuerung beibehalten.
        if (
          window.matchMedia('(min-width: 990px)').matches &&
          window.getComputedStyle(thumbnailList).flexDirection ===
            'column'
        ) {
          const listBounds = thumbnailList.getBoundingClientRect();
          const itemBounds = thumbnail.getBoundingClientRect();
          const inset = 4;

          if (itemBounds.top < listBounds.top + inset) {
            thumbnailList.scrollTop +=
              itemBounds.top - listBounds.top - inset;
          } else if (
            itemBounds.bottom > listBounds.bottom - inset
          ) {
            thumbnailList.scrollTop +=
              itemBounds.bottom - listBounds.bottom + inset;
          }

          return;
        }

        if (
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        thumbnailList.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}

/* Fascina: vertikale Desktop-Pfeile; mobile Originalsteuerung bleibt erhalten. */
(function () {
  if (window.fascinaVerticalThumbnailArrows) return;
  window.fascinaVerticalThumbnailArrows = true;
  const controllers = new Map();

  function initializeRails() {
    controllers.forEach(function (dispose, rail) {
      if (!rail.isConnected) {
        dispose();
        controllers.delete(rail);
      }
    });
    document.querySelectorAll('[id^="MainProduct-"] .product media-gallery > [id^="GalleryThumbnails-"]').forEach(function (rail) {
      if (controllers.has(rail)) return;
      const list = rail.querySelector('.thumbnail-list');
      const previous = rail.querySelector('.slider-button--prev');
      const next = rail.querySelector('.slider-button--next');
      if (!list || !previous || !next) return;
      const abort = new AbortController();
      const originalLabels = [previous.getAttribute('aria-label'), next.getAttribute('aria-label')];
      let wasVertical = null;
      let frame = 0;
      function isVertical() {
        return window.matchMedia('(min-width: 990px)').matches && getComputedStyle(list).flexDirection === 'column';
      }
      function updateArrows() {
        frame = 0;
        if (!rail.isConnected) return;
        const vertical = isVertical();
        if (!vertical) {
          rail.removeAttribute('data-fv-overflow');
          if (wasVertical) {
            [previous, next].forEach(function (button, index) {
              if (originalLabels[index] === null) button.removeAttribute('aria-label');
              else button.setAttribute('aria-label', originalLabels[index]);
            });
            list.scrollTop = 0;
            if (typeof rail.resetPages === 'function') rail.resetPages();
          }
          wasVertical = false;
          return;
        }
        wasVertical = true;
        previous.setAttribute('aria-label', 'Miniaturen nach oben');
        next.setAttribute('aria-label', 'Miniaturen nach unten');
        const maximum = Math.max(0, list.scrollHeight - list.clientHeight);
        const overflow = String(maximum > 2);
        if (rail.dataset.fvOverflow !== overflow) rail.dataset.fvOverflow = overflow;
        const atStart = list.scrollTop <= 2;
        const atEnd = list.scrollTop >= maximum - 2;
        if (previous.disabled !== atStart) previous.disabled = atStart;
        if (next.disabled !== atEnd) next.disabled = atEnd;
      }
      function scheduleUpdate() {
        if (!frame) frame = requestAnimationFrame(updateArrows);
      }
      function move(event, direction) {
        if (!isVertical()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const visibleItems = Array.from(list.children).filter(function (item) { return item.getBoundingClientRect().height > 0; });
        const first = visibleItems[0];
        const step = first ? first.getBoundingClientRect().height + (parseFloat(getComputedStyle(list).rowGap) || 0) : 70;
        const maximum = Math.max(0, list.scrollHeight - list.clientHeight);
        // Native Schrittweite beibehalten: vorhandenes data-step, standardmäßig 1.
        const count = Number(event.currentTarget.dataset.step) || 1;
        const target = Math.min(maximum, Math.max(0, list.scrollTop + direction * step * count));
        list.scrollTo({top: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        scheduleUpdate();
      }
      previous.addEventListener('click', function (event) { move(event, -1); }, {capture: true, signal: abort.signal});
      next.addEventListener('click', function (event) { move(event, 1); }, {capture: true, signal: abort.signal});
      list.addEventListener('scroll', scheduleUpdate, {passive: true, signal: abort.signal});
      list.addEventListener('load', scheduleUpdate, {capture: true, signal: abort.signal});
      window.addEventListener('resize', scheduleUpdate, {signal: abort.signal});
      const sizeObserver = new ResizeObserver(scheduleUpdate);
      sizeObserver.observe(list);
      const buttonObserver = new MutationObserver(scheduleUpdate);
      [previous, next].forEach(function (button) {
        buttonObserver.observe(button, {attributes: true, attributeFilter: ['disabled']});
      });
      const listObserver = new MutationObserver(scheduleUpdate);
      listObserver.observe(list, {childList: true});
      controllers.set(rail, function () {
        abort.abort();
        sizeObserver.disconnect();
        buttonObserver.disconnect();
        listObserver.disconnect();
        if (frame) cancelAnimationFrame(frame);
      });
      scheduleUpdate();
    });
  }
  initializeRails();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRails, {once: true});
  document.addEventListener('shopify:section:load', initializeRails);
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (dispose, rail) {
      if (event.target.contains(rail)) {
        dispose();
        controllers.delete(rail);
      }
    });
  });
})();
